import React, {Component} from 'react'
import {Form, Col, Row} from 'react-bootstrap';
import {Ar_Department, Ar_Email, Ar_JobTitle, Ar_Mobile, Ar_Name, Ar_Website, Flag} from "../Redux/action";
import {connect} from "react-redux";
import AiYearLogoToggle from './AiYearLogoToggle';


class ArabicForm extends Component {

    handleFlag = () => {
        if (this.props.name === ''&& this.props.email === '' && this.props.jobTitle === '' &&
            this.props.department === '' && this.props.mobile === '' && this.props.website === ''&&
            this.props.linkedin === '' && this.props.facebook === '' && this.props.twitter === '' &&
            this.props.github === '') {
            this.props.flag(false)
        }
    }


    async setNameValue(event) {
        event.persist();
        await this.props.ar_name(event.target.value)
        if (event.target.value === '') {
            this.handleFlag();
        } else
            this.props.flag(true)
    }

    async setEmailValue(event) {
        event.persist();
        await this.props.ar_email(event.target.value)
        if (event.target.value === '') {
            this.handleFlag();
        } else
            this.props.flag(true)

    }

    async setJobTitleValue(event) {
        event.persist();
        await this.props.ar_jobTitle(event.target.value)
        if (event.target.value === '') {
            this.handleFlag();
        } else
            this.props.flag(true)
    }

    async setDepartmentValue(event) {
        event.persist();
        await this.props.ar_department(event.target.value)
        if (event.target.value === '') {
            this.handleFlag();
        } else
            this.props.flag(true)

    }

    async setMobileValue(event) {
        event.persist();
        await this.props.ar_mobile(event.target.value)
        if (event.target.value === '') {
            this.handleFlag();
        } else
            this.props.flag(true)

    }

    async setWebsiteValue(event) {
        event.persist();
        await this.props.ar_website(event.target.value)
        if (event.target.value === '') {
            this.handleFlag();
        } else
            this.props.flag(true)

    }


    render() {
        return (
            <Form className="mt-2 justify   p-1" style={(this.props.language === 'ar') ? {
                direction: "ltr",
                textAlign: "right"
            } : {textAlign: "right"}}>
                <Row>
                    <Col lg="6">
                        <Form.Group as={Row} controlId="formPlaintextName">
                            <Form.Label column sm="12">
                                الأسم الكامل
                            </Form.Label>
                            <Col sm="12">
                                <Form.Control type="text" className="right-text" value={this.props.name} onChange={this.setNameValue.bind(this)} placeholder="محمد عبدالله"/>
                            </Col>
                        </Form.Group>
                    </Col>
                    <Col lg="6">
                        <Form.Group as={Row} controlId="formPlaintextJobTitle">
                            <Form.Label column sm="12">
                                المسمى الوظيفي
                            </Form.Label>
                            <Col sm="12">
                                <Form.Control type="text" className="right-text" value={this.props.jobTitle} onChange={this.setJobTitleValue.bind(this)} placeholder="المسمى الوظيفي"/>
                            </Col>
                        </Form.Group>
                    </Col>
                    <Col lg="6">
                        <Form.Group as={Row} controlId="formPlaintextDepartment">
                        <Form.Label column sm="12">
                            القسم
                        </Form.Label>
                        <Col sm="12">
                            <Form.Control type="text" className="right-text" value={this.props.department} onChange={this.setDepartmentValue.bind(this)} placeholder="القسم"/>
                        </Col>
                        </Form.Group>
                    </Col>
                    <Col lg="6">
                        <Form.Group as={Row} controlId="formPlaintextMobile">
                        < Form.Label column sm="12">
                            الهاتف
                        </Form.Label>
                        <Col sm="12">
                            <Form.Control className="text-right" type="tel" value={this.props.mobile} onChange={this.setMobileValue.bind(this)} placeholder="011 / 055"/>
                        </Col>
                        </Form.Group>
                    </Col>

                    <Col lg="12">
                        <Form.Group as={Row} controlId="formPlaintextEmail">
                        <Form.Label column sm="12">
                            البريد الإلكتروني
                        </Form.Label>
                        <Col sm="12">
                            <Form.Control
                                className="text-right"
                                type="email"
                                value={this.props.email}
                                onChange={this.setEmailValue.bind(this)}
                                placeholder="m.abdullah@ksu.edu.sa"/>
                        </Col>
                        </Form.Group>
                    </Col>
                    <Col lg="12">
                        <Form.Group as={Row} controlId="formPlaintextWebsite">
                        <Form.Label column sm="12">
                            الموقع الشخصي
                        </Form.Label>
                        <Col sm="12">
                            <Form.Control className="text-right" value={this.props.website} type="url" onChange={this.setWebsiteValue.bind(this)} placeholder="https://ksu.edu.sa/ar"/>
                        </Col>
                        </Form.Group>
                    </Col>
                    <Col lg="12">
                        <AiYearLogoToggle/>
                    </Col>
                </Row>
            </Form>
        )
    }
}

function mapStateToProps(state) {
    return {
        language: state.TranslationReducer.language,
        name: state.ArabicReducer.ar_name,
        email: state.ArabicReducer.ar_email,
        jobTitle: state.ArabicReducer.ar_jobTitle,
        department: state.ArabicReducer.ar_department,
        mobile: state.ArabicReducer.ar_mobile,
        website: state.ArabicReducer.ar_website,
        linkedin: state.socialReducer.linkedin,
        twitter: state.socialReducer.twitter,
        facebook: state.socialReducer.facebook,
        github: state.socialReducer.github,
    }
}


function mapDispatchToProps(dispatch) {
    return {
        flag: (flag) => dispatch(Flag(flag)),
        ar_name: (name) => dispatch(Ar_Name(name)),
        ar_email: (email) => dispatch(Ar_Email(email)),
        ar_jobTitle: (job) => dispatch(Ar_JobTitle(job)),
        ar_department: (department) => dispatch(Ar_Department(department)),
        ar_mobile: (mobile) => dispatch(Ar_Mobile(mobile)),
        ar_website: (website) => dispatch(Ar_Website(website)),

    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ArabicForm);
